import SiteRentalsServices from '@/services/SiteRentalsServices'
import SelectionServices from '@/services/SelectionServices'
import { mutations } from "@/store/types"
import { getFormattedDate } from '@/mixins/utils'
import { getCookie } from '@/mixins/utils'
import { setCookie } from '@/mixins/utils'

export const siteRentals = {
  data() {
    return {
      processing: false,
      fetchEv: null,      
      filteredSites: [],
      cachedSites: {},
      selections: [],
      descriptions: '',   
      displayedDates: [
        {
          dateString: String,
          dateTime: Number,
          descDay: String,
          descDate: String
        }
      ],
      displayedCheckInDate: '',
      displayedCheckOutDate: '',
      checkOutDate: null,
      checkInDate: null,
      loadingCalendar: true                       
    }
  },
  created() { },
  methods: {
    onCheckInDate(event) {
      if (!event) {
        return
      }

      const begDate = new Date(event)
      this.loadingCalendar = true;

      if (begDate instanceof Date) {
        this.beginDate = getFormattedDate(begDate)
        this.checkInDate = this.beginDate
        this.displayedCheckInDate = this.checkInDate
        this.setSiteRentalsCookie()
        this.fetchSiteData(true)
      }

      return
    },
    onCheckOutDate(event) {
      if (!event) {
        return
      }

      const endDate = new Date(event)

      if (endDate instanceof Date) {
        this.checkOutDate = getFormattedDate(endDate)
        this.displayedCheckOutDate = this.checkOutDate        
        this.setSiteRentalsCookie()
      }

      return
    },      
    onRefresh() {
      this.loadingCalendar = true;
      this.cachedSites = {}
      this.fetchSiteData(true)

      return
    },
    fetchSiteData(dateChange) {
      if (dateChange) {
        this.updateDisplayedDates()

        this.filteredSites.forEach((site) => {
          site.dates = []
        })
      }

      if (this.fetchEv) {
        clearTimeout(this.fetchEv)
      }

      this.fetchEv = setTimeout(() => {
        this.fetchData()
      }, 500)
    },    
    fetchData() {
      const tempFilteredSites = [...this.filteredSites]
      const cachedResults = this.checkCache()
      const siteList = cachedResults[0]
      const selectionSiteList = cachedResults[1]

      if (!siteList.length) {
        this.loadingCalendar = false;
        tempFilteredSites.forEach((site) => {
          site.dates = this.setSiteDates(this.cachedSites[site.siteId])
        })

        this.changeData(tempFilteredSites)
      } else {
        this.processing = true

        SiteRentalsServices.getSiteData(siteList)
          .then((response) => {
            const cacheDateTime = new Date().getTime() + 300000

            tempFilteredSites.forEach((site) => {
              const rec = response.sitedata.find(
                (s) => s.siteId === site.siteId
              )

              if (rec) {
                this.cachedSites[rec.siteId] = [
                  ...this.cachedSites[rec.siteId],
                  ...rec.dates.map((d) => {
                    return Object.assign({}, d, {
                      cached: cacheDateTime,
                      dateString: d.date,
                      date: new Date(d.date)
                    })
                  })
                ]
              }

              site.dates = this.setSiteDates(this.cachedSites[site.siteId])
            })

            this.validateSelections(response.sitedata)         
            this.changeData(tempFilteredSites)

            if (!selectionSiteList.length) {
              this.loadingCalendar = false;
              this.processing = false;
            }

          })
          .catch(() => {
            this.processing = false;
            this.loadingCalendar = false;
          })

        if (selectionSiteList.length) {
          SiteRentalsServices.getSiteData(selectionSiteList)
            .then((response) => {
              this.validateSelections(response.sitedata)

              this.processing = false;
              this.loadingCalendar = false;
            })
            .catch(() => {
              this.processing = false;
              this.loadingCalendar = false;
            })
        }
      }
    },        
    checkCache() {
      const siteList = []
      const selectionSiteList = []
      const checkDateTime = new Date().getTime()
      const displayedDates = this.displayedDates.map((d) => d.dateString)

      this.filteredSites.forEach((s) => {
        if (!this.cachedSites[s.siteId]) this.cachedSites[s.siteId] = []

        this.cachedSites[s.siteId] = this.cachedSites[s.siteId].filter((c) => {
          return c.cached >= checkDateTime
        })

        const cachedGoodDates = this.cachedSites[s.siteId].map((d) =>
          getFormattedDate(d.date)
        )
        const dateList = displayedDates.filter(
          (d) => !cachedGoodDates.includes(d)
        )
        const selectionDateList = []

        const selectionSite = this.selections.find(
          (ss) => ss.siteId === s.siteId
        )
        if (selectionSite) {
          const beginDisplayedDate = new Date(dateList[0])
          const endDisplayedDate = new Date(dateList[dateList.length - 1])
          const selectionEndDate = new Date(selectionSite.endDate)
          const currDate = new Date(selectionSite.beginDate)

          while (currDate <= selectionEndDate) {
            if (currDate < beginDisplayedDate || currDate > endDisplayedDate)
              selectionDateList.push(getFormattedDate(currDate))
            currDate.setDate(currDate.getDate() + 1)
          }
        }

        if (dateList.length)
          siteList.push({ siteId: s.siteId, dateList: dateList })
        if (selectionDateList.length)
          selectionSiteList.push({
            siteId: s.siteId,
            dateList: selectionDateList
          })
      })

      return [siteList, selectionSiteList]
    },    
    setSiteDates(cachedSite) {
      const displayedDates = this.displayedDates.map((d) => d.dateString)

      return cachedSite
        .filter((d) => {
          return displayedDates.includes(d.dateString)
        })
        .sort((a, b) => {
          const aDate = a.date.getTime()
          const bDate = b.date.getTime()

          if (aDate > bDate) return 1
          if (aDate < bDate) return -1

          return 0
        })
    },    
    validateSelections(siteData) {
      const tempSelections = []
      this.selections.forEach((selection) => {
        let allGoodDates = true

        const site = this.filteredSites.find(
          (s) => s.siteId === selection.siteId
        )

        if (site) siteData
          .filter((site) => site.siteId === selection.siteId)[0]
          .dates.forEach((date) => {
            const currDate = new Date(date.date).valueOf()
            if (
              selection.beginDateTime <= currDate &&
              currDate < selection.endDateTime &&
              date.status !== 'A'
            ) {
              allGoodDates = false
            }
          })

        if (allGoodDates) tempSelections.push(selection)
      })
      this.selections = tempSelections
      this.filteredSites.forEach((site) => {
        site.beginDate = undefined
        site.endDate = undefined
      })
      this.setSiteSelections()
    },
    setSiteSelections() {
      this.selections.forEach((selection) => {
        const site = this.filteredSites.find(
          (s) => s.siteId === selection.siteId
        )
        if (site) {
          site.beginDate = selection.beginDateTime
          site.endDate = selection.endDateTime
        }
      })

      return
    },  
    makeSelection(site, removed, newBeginDate, newEndDate) {
      const tempBeginDate = new Date(newBeginDate)
      const tempEndDate = new Date(newEndDate)
      const tempIntBeginTime = site.beginTimeIntList[tempBeginDate.getDay()]
      const tempIntEndTime = site.endTimeIntList[tempEndDate.getDay()]

      const fieldParams = {
        "UpdateRecord": "yes",
        "Module": "RN",
        "RNFMIDList": site.siteId,
        "GlobalSalesArea_RNItemBeginDate": getFormattedDate(tempBeginDate),
        "GlobalSalesArea_RNItemBeginTime": tempIntBeginTime,
        "GlobalSalesArea_RNItemEndDate": getFormattedDate(tempEndDate),
        "GlobalSalesArea_RNItemEndTime": tempIntEndTime
      }

      if (!removed) fieldParams.PreChecks = "CheckAvailableDays"   

      this.processing = true

      SelectionServices.updateSelection( fieldParams )
        .then((response) => {
          if (response.status === "Added" || response.status === "Changed") {
            site.beginDate = newBeginDate
            site.endDate = newEndDate
            this.descriptions = response.descriptions
            this.addToSelectionList(site, true)
          } else if (response.status === "Removed") {
            site.beginDate = undefined
            site.endDate = undefined
            this.descriptions = response.descriptions
            this.addToSelectionList(site, false)
          }

          if (response.error) {
            this.$store.commit(mutations.ADD_MESSAGE, {
              type: 'error',
              text: response.error
            })
          }

          this.processing = false
        })
        .catch(() => {
          this.processing = false
        })
        
      return 
    },     
    addToSelectionList(site, push) {
      const tempBeginDate = new Date(site.beginDate)
      const tempEndDate = new Date(site.endDate)

      this.selections = this.selections.filter(function (s) {
        return s.siteId != site.siteId
      })
        
      if (push) this.selections.push({
        siteId: site.siteId,
        beginDate: getFormattedDate(tempBeginDate),
        endDate: getFormattedDate(tempEndDate),
        beginDateTime: tempBeginDate.getTime(),
        endDateTime: tempEndDate.getTime()
      })

      return 
    },  
    initSelections() {
      if (this.initselectionstate === '') return

      this.initselectionstate.split(',').forEach((state) => {
        const s = state.split('|')
        const siteId = parseInt(s[1])
        const beginDate = s[3]
        const endDate = s[5]
        const beginDateTime =  new Date(beginDate).getTime()
        const endDateTime = new Date(endDate).getTime()
        const selection = {
          siteId: siteId,
          beginDate: beginDate,
          endDate: endDate,
          beginDateTime: beginDateTime,
          endDateTime: endDateTime
        }

        this.selections.push(selection)
      })

      SelectionServices.getDescriptions()
        .then((response) => {
          this.descriptions = response
        })
        .catch(() => {
        })

      return 
    },  
    submitForm() {
      if (this.selections.length === 0) {
        this.$store.commit(mutations.ADD_MESSAGE, {
          type: 'error',
          text: 'There are no selections to add to the cart.'
        })

        return
      }

      this.processing = true
      this.$refs.form.submit()
    },   
    getSiteRentalsCookie() {
      let cookie = getCookie('_siterentals')
      return cookie == null ? null : cookie.split('|')
    },
    setSiteRentalsCookie() {
      setCookie('_siterentals', this.beginDate + '|' + (this.checkInDate ? this.checkInDate : '') + '|' + (this.checkOutDate ? this.checkOutDate : ''), 1800)
    },  
    clearSelections() {
      this.selections = []

      this.filteredSites.forEach((site) => {
        site.beginDate = undefined
        site.endDate = undefined
      })

      this.clearSelectionState()

      return
    },     
    clearSelectionState() {
      this.processing = true

      SelectionServices.clearSelection()
        .then(() => {
          this.processing = false
        })
        .catch(() => {
          this.processing = false
        })

      return
    },    
  }
}